import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'

import AuthDataService from 'src/services/auth.service'
import { ILoginUserWeb3Dto } from 'src/types'

import { ROUTES, STORAGE_KEYS } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'

const useWeb3Login = () => {
  const navigate = useNavigate()

  return useMutation((dto: ILoginUserWeb3Dto) => AuthDataService.loginWeb3(dto), {
    onSuccess: (data) => {
      if (!data) return

      if (
        'registerByWalletAddress' in data &&
        typeof data.registerByWalletAddress !== 'undefined' &&
        data.registerByWalletAddress
      ) {
        return navigate(
          `${ROUTES.LOGIN_EMAIL}?userId=${data.userId}&address=${data.registerByWalletAddress}`,
        )
      }

      if (
        'hasFinishedRegistration' in data &&
        typeof data.hasFinishedRegistration !== 'undefined' &&
        !data.hasFinishedRegistration
      ) {
        return navigate(`${ROUTES.REGISTER_FINISH}?userId=${data.id}&email=${data.email}`)
      }

      if ('accessToken' in data) {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.accessToken)
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refreshToken)

        navigate(
          data.accountId
            ? joinAbsRoute(ROUTES.ACCOUNTS, data.accountId, ROUTES.DASHBOARD)
            : data.scannerAccountId
              ? joinAbsRoute(ROUTES.ACCOUNTS, data.scannerAccountId, ROUTES.SCAN_HISTORY)
              : data?.customer
                ? joinAbsRoute(ROUTES.USER, ROUTES.USER_DASHBOARD)
                : joinAbsRoute(ROUTES.ACCOUNTS),
        )
      }
    },
  })
}

export { useWeb3Login }
